import angular from 'angular'
import routers from './routers.js'
import statisticsReportCtrl from './statisticsReportCtrl'
import fieldConfig from './fieldConfig.js'
const module = angular
    .module('declaration.declareASummary.statisticsReport', [])
    .config([
        '$stateProvider',
        ($stateProvider) => {
            Object.keys(routers).forEach((router) => {
                $stateProvider.state(routers[router].state, routers[router].config)
            })
        },
    ])
    .controller('statisticsReportCtrl', statisticsReportCtrl)
    .value('SRFieldConfig', fieldConfig)
export default module.name



// WEBPACK FOOTER //
// ./src/app/declaration/declareASummary/statisticsReport/index.js